<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>{{ title }}</h3>
        <form>
          <table>
            <tr>
              <td>
                Content:
              </td>
              <td>
                <textarea
                  v-model="testimonial.content"
                  name="content"
                  cols="50"
                  rows="20"
                  maxlength="5000"
                ></textarea>
              </td>
            </tr>
            <tr>
              <td>
                Author:
              </td>
              <td>
                <input
                  v-model="testimonial.author"
                  type="text"
                  name="author"
                  size="33"
                  maxlength="100"
                />
              </td>
            </tr>
            <tr>
              <td>
                Type: (free member, customer, etc)
              </td>
              <td>
                <input
                  v-model="testimonial.type"
                  type="text"
                  name="type"
                  size="20"
                  maxlength="20"
                />
              </td>
            </tr>
          </table>
          <p>
            <input
              type="submit"
              name="submit"
              value="Submit"
              @click.prevent="save"
            />
          </p>
        </form>
        <!-- main-colum END here -->
      </div>
      <!-- container END here -->
    </div>
    <!-- content END here -->
  </div>
</template>

<script>
import TestimonialRepository from "../../data/testimonial.repository";
export default {
  data() {
    return {
      title: "",
      testimonial: {
        id: "",
        content: "",
        author: "",
        type: "",
      },
    };
  },
  created() {
    if (this.$route.params.id) {
      TestimonialRepository.get(this.$route.params.id).then((test) => {
        this.testimonial.id = test.id;
        this.testimonial.content = test.content;
        this.testimonial.author = test.author;
        this.testimonial.type = test.type;
        this.title = "Edit Testimonial";
      });
    } else this.title = "Add Testimonial";
  },
  methods: {
    save() {
      TestimonialRepository.save(this.testimonial)
        .then((result) => {
          this.$root.$refs.toastr.s("Testimonial saved");
          this.$router.push("/admin");
        })
        .catch(() => this.$root.$refs.toastr.e("An error occurred"));
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Testimonial.vue?4464840e